import {compact} from 'lodash';

import {AnnotationModel} from '../../../src/models/api/annotationModel';
import {CommentModel} from '../../../src/models/api/commentModel';
import {ApiCommentDataGroup, DataGroupModel} from '../../../src/models/api/dataGroupModel';
import {createOfflineCache} from './offlineResources';

/*
 * Draft comment temporary (while saving on the server) offline caching.
 */

const cache = createOfflineCache('draftComments', ApiCommentDataGroup, (dg) => dg.updatedAt || 0);

function addAsync(comment: CommentModel, annotation: AnnotationModel | null) {
  const dataGroup: DataGroupModel = {
    comments: [comment],
    annotations: compact([annotation]),
  };

  return cache.addAsync(comment.uid, dataGroup);
}

function removeAsync(commentUid: string) {
  return cache.removeAsync(commentUid);
}

export const offlineDraftComments = {
  addAsync,
  removeAsync,
  readAllAsync: () => cache.readAllAsync(),
  readAllIdsAsync: () => cache.readAllIdsAsync(),
  addedIds$: cache.addedIds$,
};
